import React from 'react'
import {useStore} from 'react-hookstore'
import {textStrings as txt} from './textStrings'

export const LangButton = () => {
  const [lang, setLang] = useStore('language')
  const toggleLang = () => {
    setLang(lang === 0 ? 1 : 0)
  }
  return(
    <span className='dropbtn' onClick={toggleLang}>{txt.language[lang]}</span>
  )
}

